import { render, staticRenderFns } from "./BuscaComponent.vue?vue&type=template&id=bff23018"
import script from "./BuscaComponent.vue?vue&type=script&lang=js"
export * from "./BuscaComponent.vue?vue&type=script&lang=js"
import style0 from "./BuscaComponent.vue?vue&type=style&index=0&id=bff23018&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports